<div class="m-message"
     :class="{'m--is-state-confirmation': isStateConfirmation,
            'm--is-state-information': isStateInformation,
            'm--is-state-warning': isStateWarning,
            'm--is-state-error': isStateError,
            'm--is-skin-default': isSkinDefault,
            'm--is-skin-light': isSkinLight,
            'm--is-skin-page': isSkinPage,
            'm--is-skin-page-light': isSkinPageLight}"
     v-if="propVisible">
    <div class="m-message__wrap"
         v-if="isNotSkinPage">
        <div class="m-message__icon"
             v-if="icon">
            <m-svg :name="getIcon()"
                    width="1em"
                    height="1em" />
        </div>
        <div class="m-message__body"
             :class="{'m--has-close-button': closeButton}">
            <h2 class="m-message__title"
                v-if="title">{{ title }}</h2>
            <div class="m-message__text"
                 v-if="$slots.default">
                <slot />
            </div>
        </div>
        <m-icon-button class="m-message__body__close-button"
                       v-if="showCloseButton"
                       icon-name="m-svg__close-clear"
                       icon-size="10px"
                       @click="emitClose">
            {{ $i18n.translate('m-message:close') }}
        </m-icon-button>
    </div>
    <m-message-page class="m-message__page"
                    v-else
                    :state="state"
                    :skin="skinPageValue"
                    :title="title">
        <slot />
    </m-message-page>
</div>
